import type { ComponentType } from "react";
import {
  BarChart3,
  CalendarDays,
  CalendarSync,
  Camera,
  CheckCircle,
  ClipboardCheck,
  ClipboardList,
  DollarSign,
  ListPlus,
  MapPin,
  Package,
  PackageOpen,
  PackageSearch,
  Palmtree,
  PartyPopper,
  PlusCircle,
  Repeat,
  Settings,
  ShoppingBasket,
  Truck,
  UserCog,
  Users,
} from "lucide-react";
import type { FeatureId } from "@/lib/featureAccess";

export interface AppTile {
  feature: FeatureId;
  title: string;
  description: string;
  icon: ComponentType<{ className?: string }>;
  href: string;
  color: string;
}

export const HOME_TILES: readonly AppTile[] = [
  {
    feature: "newOrder",
    title: "Nouvelle commande",
    description: "Créer une commande",
    icon: PlusCircle,
    href: "/commandes?create=true",
    color: "bg-amber-500",
  },
  {
    feature: "openOrders",
    title: "Commandes ouvertes",
    description: "Voir les brouillons",
    icon: PackageOpen,
    href: "/commandes-ouvertes",
    color: "bg-orange-500",
  },
  {
    feature: "orderTracking",
    title: "Suivi",
    description: "Suivre les commandes",
    icon: PackageSearch,
    href: "/commandes",
    color: "bg-blue-500",
  },
  {
    feature: "recurringOrders",
    title: "Commandes récurrentes",
    description: "Planifier les livraisons",
    icon: Repeat,
    href: "/commandes-recurrentes",
    color: "bg-cyan-600",
  },
  {
    feature: "clients",
    title: "Clients",
    description: "Gérer les clients",
    icon: Users,
    href: "/clients",
    color: "bg-purple-500",
  },
  {
    feature: "media",
    title: "Photos",
    description: "Galerie de médias",
    icon: Camera,
    href: "/medias",
    color: "bg-pink-500",
  },
  {
    feature: "catalog",
    title: "Catalogue",
    description: "Produits & variantes",
    icon: Package,
    href: "/catalogue",
    color: "bg-green-500",
  },
  {
    feature: "deliveries",
    title: "Livraisons",
    description: "Ma tournée de livraison",
    icon: Truck,
    href: "/livraisons",
    color: "bg-orange-500",
  },
  {
    feature: "deliveryManagement",
    title: "Gestion des livraisons",
    description: "Assigner les livraisons",
    icon: MapPin,
    href: "/gestion-livraisons",
    color: "bg-red-500",
  },
  {
    feature: "orderListing",
    title: "Nouveau listing",
    description: "Créer un listing de commandes",
    icon: ListPlus,
    href: "/commandes-en-lot",
    color: "bg-indigo-500",
  },
  {
    feature: "verifications",
    title: "Vérifications",
    description: "Vérifier les photos de bouquets",
    icon: CheckCircle,
    href: "/verifications",
    color: "bg-teal-500",
  },
  {
    feature: "cashRegisters",
    title: "Caisses",
    description: "Suivi des montants de caisse",
    icon: DollarSign,
    href: "/caisses",
    color: "bg-green-600",
  },
  {
    feature: "statistics",
    title: "Statistiques",
    description: "Analyses et performances",
    icon: BarChart3,
    href: "/statistiques",
    color: "bg-indigo-600",
  },
  {
    feature: "subscriptions",
    title: "Abonnements",
    description: "Gérer les abonnements floraux",
    icon: CalendarSync,
    href: "/abonnements",
    color: "bg-emerald-500",
  },
  {
    feature: "workshopValidations",
    title: "Validations atelier",
    description: "Valider les tâches terminées",
    icon: ClipboardCheck,
    href: "/validations-abonnements",
    color: "bg-teal-600",
  },
  {
    feature: "flowerPurchases",
    title: "Achats fleurs",
    description: "Listes d’achats de fleurs à prévoir",
    icon: ShoppingBasket,
    href: "/achats-fleurs",
    color: "bg-emerald-700",
  },
  {
    feature: "myTasks",
    title: "Mes tâches",
    description: "Les tâches qui vous sont assignées",
    icon: ClipboardList,
    href: "/mes-taches",
    color: "bg-sky-600",
  },
  {
    feature: "events",
    title: "Évènements",
    description: "Gérer les évènements",
    icon: PartyPopper,
    href: "/evenements",
    color: "bg-violet-500",
  },
  {
    feature: "calendar",
    title: "Calendrier",
    description: "Planning des préparations et évènements",
    icon: CalendarDays,
    href: "/calendrier",
    color: "bg-cyan-500",
  },
  {
    feature: "leave",
    title: "Congés payés",
    description: "Soldes et demandes de congés",
    icon: Palmtree,
    href: "/conges",
    color: "bg-lime-600",
  },
  {
    feature: "team",
    title: "Équipe",
    description: "Gérer l'équipe",
    icon: UserCog,
    href: "/equipe",
    color: "bg-indigo-500",
  },
  {
    feature: "settings",
    title: "Paramètres",
    description: "Configuration et notifications",
    icon: Settings,
    href: "/parametres",
    color: "bg-gray-500",
  },
];
